<template>
  <div>
    <div class="switch-bar">
      <div class="tab" v-for="(tab, index) in data" :key="index" @click="changeTab(index, tab)" :class="{ active: tabIndex === index }">
        <span>{{ tab.name ? tab.name : tab }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    tabIndex: {
      type: Number
    }
  },
  methods: {
    changeTab(index, tab) {
      this.$emit('changeTab', index, tab)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.switch-bar {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 4em;
  background-color: #fff;
  .tab {
    width: 50%;
    text-align: center;
    font-size: 0.37rem;
    color: @title-color-h1;
    position: relative;
    transition: 0.2s all linear;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 100%;
      border-bottom: 2px solid #000;
      transition: 0.2s all linear;
      border-bottom: 1px solid @main_color;
      transform: translate(0, -0.6em);
    }
    &.active::after {
      width: 64%;
      left: 18%;
      top: 0;
    }
    &.active > span {
      color: @main_color;
    }
    span {
      padding: 0 0.5em 0.4em;
      white-space: pre;
    }
  }
  .active ~ .tab::after {
    left: 50%;
  }
  .tab::before {
    content: '';
    position: absolute;
    width: 1px;
    right: 0;
    top: 20%;
    height: 60%;
    background: @bd_color;
  }
  .tab:last-of-type::before {
    display: none;
  }
}
</style>
